module.exports = __webpack_public_path__ + "media/images/athletes/4341-1dcb7ea019b9f18d2bf222a2324555e1.png";